
import React, {useState} from "react";
import PropTypes from "prop-types";
import {drawerWidth} from "./CustomToolbarHelper";
import KeycloakService from "../../../config/keycloak";
import MenuDropdown from "../../../shared/components/menu-dropdown/MenuDropdown";
import ProfileMenuDropdown from "../../../shared/components/menu-dropdown/ProfileMenuDropdown";
import {languageMenuItems, profileMenuItems} from "./CustomToolbarHelper";
import {getLanguageIcon} from "../../../shared/utils/language";
import {T} from "@tolgee/react";
import {colors} from "../../../shared/theme/colors";
import {AppBar, Avatar, Box, Button, IconButton, Toolbar, Tooltip, Typography} from "@mui/material";
import {ExitToApp, Menu} from "@mui/icons-material";
import {theme} from "../../../shared/theme/theme";
import useSelectedLanguage from "../../../shared/hooks/useSelectedLanguage";


const CustomToolbar = (props) => {

    const [anchorEl, setAnchorEl] = useState({
        profile: null,
        language: null
    });
    const selectedLanguage = useSelectedLanguage();

    const handleMenuOpen = (event, key) => {
        setAnchorEl({
            ...anchorEl,
            [key]: event.currentTarget,
        })
    }

    const handleMenuClose = (key) => {
        setAnchorEl({
            ...anchorEl,
            [key]: null,
        })
    }

    const getAvatar = <Avatar
        style={{
            backgroundColor: colors.primary.main, marginRight: "0.25em",
            height: "32px", width: "32px"}}
    >
        {KeycloakService.getNameSurnameInitials()}
    </Avatar>

    return (
        <AppBar position="fixed" sx={{
            [theme.breakpoints.up('sm')]: {
                width: `calc(100% - ${drawerWidth}px)`,
                marginLeft: `${drawerWidth}px`,
            },
            backgroundColor: "#fff"   // explicit: white top bar (was accidentally wired to contrastText)
        }}>
            <Toolbar>
                <IconButton
                    aria-label="open drawer"
                    edge="start"
                    onClick={props.handleSidebarToggle}
                    sx={{
                        marginRight: theme.spacing(2),
                        [theme.breakpoints.up('sm')]: {
                            display: 'none',
                        },
                    }}
                >
                    <Menu/>
                </IconButton>
                <Typography variant="h6" noWrap sx={{flexGrow: "1"}}>
                    <T keyName="app-title" defaultValue="Alosys License Manager"/>
                </Typography>
                <Box display="flex">
                    <IconButton
                        style={{marginRight: "0.25em"}}
                        size="small"
                        edge="end"
                        aria-controls={"language-menu"}
                        onClick={(e) => handleMenuOpen(e, "language")}
                        color="inherit"
                    >
                        {getLanguageIcon(selectedLanguage)}
                    </IconButton>
                    <Button
                        size="small"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={"primary-search-account-menu"}
                        aria-haspopup="true"
                        onClick={(e) => handleMenuOpen(e, "profile")}
                        color="inherit"
                    >
                        {getAvatar}
                        <Typography variant="body2">{KeycloakService.getUsername()}</Typography>
                    </Button>
                </Box>
            </Toolbar>
            <MenuDropdown anchorEl={anchorEl.language}
                          handleMenuClose={() => handleMenuClose("language")}
                          menuId={"language-menu"}
                          menuItems={languageMenuItems}/>
            <ProfileMenuDropdown anchorEl={anchorEl.profile}
                                 avatar={getAvatar}
                                 handleMenuClose={() => handleMenuClose("profile")}
                                 menuId={"primary-search-account-menu"}
                                 menuItems={profileMenuItems}
                                 username={KeycloakService.getUsername()}
                                 email={KeycloakService.getEmail()}
                                 logoutButton={<Tooltip title={<T keyName={"text-logout"} defaultValue={"Logout"}/>}>
                                     <IconButton onClick={() => KeycloakService.doLogout()}>
                                         <ExitToApp sx={{
                                             marginRight: '0.6em',
                                             rotate: '180deg',
                                         }} />
                                     </IconButton>
                                 </Tooltip>}
                                 placement={"bottom-end"}/>
        </AppBar>
    )
}

CustomToolbar.propTypes = {
    handleSidebarToggle: PropTypes.func.isRequired
}

export default CustomToolbar;
